import React, { useEffect, useState } from 'react';
import {
  TextInput,
  Button,
  Box,
  Group,
  Image,
  Center,
  Textarea,
  Grid,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import toast from 'react-hot-toast';

import { IconPhoto } from '@tabler/icons-react';

import ApiLinks from '../../Navlinks/ApiLinks';
import LoaderOverlay from '../../Utilities/LoadingOverLay';
import ImageUploadWithPreview from '../../Utilities/ImageUploadWithPreview';


function AddDeveloper() {
  const location = useLocation();
  const id = location.state?.id;
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [existingLogoPath, setExistingLogoPath] = useState(null);
  const [existingImagePath, setExistingImagePath] = useState(null);

  const form = useForm({
    initialValues: {
      id: '',
      devname: '',
      established: '',
      totalprojects: '',
      ongoing: '',
      noofcity: '',
      desc: '',
      compcode: user?.compcode || '',
    },
  });

  useEffect(() => {
    if (id) {
      setLoading(true);
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/${ApiLinks.Developer_GetById}/${id}/${user.compcode}`
        )
        .then((response) => {
          if (response.data.status && response.data.data.length > 0) {
            const developer = response.data.data[0];
            form.setValues({
              id: developer.id,
              devname: developer.devname,
              established: developer.established,
              totalprojects: developer.totalprojects,
              ongoing: developer.ongoing,
              noofcity: developer.noofcity,
              desc: developer.desc,
              compcode: developer.compcode,
            });

            if (developer.logo) {
              setExistingImagePath(`${process.env.REACT_APP_IMG_URL}/${developer.logo}`);
            }
          }
        })
        .catch((err) => {
          console.error('Error loading developer:', err);
        })
        .finally(() => setLoading(false));
    }
  }, [id, user.compcode]);

  const handleSubmit = (values) => {
    // Basic validation
    if (!values.devname.trim()) {
      toast.error('Developer name is required.');
      return;
    }
    if (!id && !selectedFile) {
      toast.error('Logo is required for new developer.');
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append('developerid', id || 0);
    formData.append('devname', values.devname);
    formData.append('established', values.established);
    formData.append('totalprojects', values.totalprojects);
    formData.append('ongoing', values.ongoing);
    formData.append('noofcity', values.noofcity);
    formData.append('desc', values.desc);
    formData.append('compcode', user?.compcode || '');
    if (selectedFile) {
      formData.append('logo', selectedFile);
    }

    const request = id && id !== 0
      ? axios.put(`${process.env.REACT_APP_API_URL}/${ApiLinks.Developer_Update}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      : axios.post(`${process.env.REACT_APP_API_URL}/${ApiLinks.Developer_Save}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

    request.then((res) => {
      if (res.data.status) {
        Swal.fire({
          title: id ? 'Updated!' : 'Created!',
          text: `Developer ${id ? 'updated' : 'created'} successfully.`,
          icon: 'success',
          confirmButtonText: 'OK',
        }).then(() => {
          navigate('/dashboard/developer');
        });
      } else {
        Swal.fire('Error!', res.data.message || 'Failed to save developer.', 'error');
      }
    })
      .catch(() => {
        Swal.fire('Error!', 'An error occurred while saving.', 'error');
      })
      .finally(() => setLoading(false));
  };

  const renderLogoPreview = () => {
    if (selectedFile) {
      return URL.createObjectURL(selectedFile);
    } else if (existingLogoPath) {
      return existingLogoPath;
    } else {
      return null;
    }
  };

  if (loading) return <LoaderOverlay />;

  return (
    <Box  mx="auto"  sx={(theme) => ({
      backgroundColor: 'white',
      padding: theme.spacing.xl,
      borderRadius: theme.radius.md,
      boxShadow: theme.shadows.md,
    })} >
      <Group position="apart" mb="md">
        <h2>{id ? 'Edit Developer' : 'Create Developer'}</h2>
        <Button onClick={() => navigate('/dashboard/developer')}>Back</Button>
      </Group>




      <form onSubmit={form.onSubmit(handleSubmit)}>
  <Grid gutter="md">


    <Grid.Col span={4}>
      <TextInput
        label="Developer Name"
        placeholder="Enter developer name"
        {...form.getInputProps('devname')}
        mt="md"
      />
    </Grid.Col>
    <Grid.Col span={2}>
      <TextInput
        label="Established"
        placeholder="Enter established year"
        {...form.getInputProps('established')}
        mt="md"
      />
    </Grid.Col>
    <Grid.Col span={2}>
      <TextInput
        label="Total Projects"
        placeholder="Enter total projects"
        {...form.getInputProps('totalprojects')}
        mt="md"
      />
    </Grid.Col>
    <Grid.Col span={2}>
      <TextInput
        label="Ongoing Projects"
        placeholder="Enter ongoing projects"
        {...form.getInputProps('ongoing')}
        mt="md"
      />
    </Grid.Col>
    <Grid.Col span={2}>
      <TextInput
        label="Number of Cities"
        placeholder="Enter number of cities"
        {...form.getInputProps('noofcity')}
        mt="md"
      />
    </Grid.Col>


    <Grid.Col span={12}>
      <Textarea
        label="Description"
        placeholder="Enter description"
        {...form.getInputProps('desc')}
        mt="md"
        minRows={6}
        maxRows={12}
      />
    </Grid.Col>
    <Grid.Col span={6}>
  

      <ImageUploadWithPreview
  selectedFile={selectedFile}
  setSelectedFile={setSelectedFile}
  existingImagePath={existingImagePath}
  setExistingImagePath={setExistingImagePath}
/>

    </Grid.Col>

   
    <Grid.Col span={12}>
      <Group position="right">
        <Button type="submit" mt="lg">
          {id ? 'Update' : 'Create'}
        </Button>
      </Group>
    </Grid.Col>
  </Grid>
</form>

    </Box>
  );
}

export default AddDeveloper;
